// extracted by mini-css-extract-plugin
var _1 = "V3SGLiEJlReEH3ySO7np";
export { _1 as "link" }
